import { render, staticRenderFns } from "./PuntosPorRonda.vue?vue&type=template&id=2e44a0f0&scoped=true"
import script from "./PuntosPorRonda.vue?vue&type=script&lang=js"
export * from "./PuntosPorRonda.vue?vue&type=script&lang=js"
import style0 from "./PuntosPorRonda.vue?vue&type=style&index=0&id=2e44a0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44a0f0",
  null
  
)

export default component.exports